import SplitText from "./vendors/SplitText3.min";
import {gsap, Power4} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import $ from 'jquery';

gsap.registerPlugin(SplitText, ScrollTrigger);

let texts_animations = {
    _config: {
        thresholdStart: 'top: 95%'
    },
    init() {
        this.titleLettering();
        this.animationBlocks();
    },
    refreshAnimations() {
        ScrollTrigger.refresh();
    },
    titleLettering() {
        gsap.utils.toArray("[data-title-animation]").forEach((elem, i) => {
            if ($(elem).data('splitted') !== true) {
                new SplitText(elem, {
                    wordsClass: "ts-word",
                    type: "chars,words",
                });
                // this.titleLetteringSetAnimation(elem);
                elem.setAttribute('data-splitted', true);
            }
        });
    },

    titleLetteringSetAnimation(elem) {
        gsap.set($(elem).find("div"), {
            rotation: "1deg",
            y: "20px",
            alpha: 0,
        });
    },

    titleAnimation(el) {
        const $el = $(el);
        // gsap.set($el, {
        //   alpha: 1,
        // });
        gsap.fromTo(
            $el.find("div"),
            {
                rotation: "1deg",
                y: "20px",
                alpha: 0,
            },
            {
                rotation: 0,
                y: 0,
                alpha: 1,
                duration: 1.0,
                stagger: 0.01,
                ease: Power4.easeOut,
            }
        );
    },
    titleAnimationLeave(el) {
        const $el = $(el);
        gsap.to(
            $el.find("div"),
            {
                rotation: "1deg",
                y: "20px",
                alpha: 0,
            }
        );
    },

    animateBlock(elem) {
        const delay = $(elem).data("delay") ? parseFloat($(elem).data("delay")) * 1000 : 0;
        setTimeout(() => {
            $(elem).addClass("is-visible");
            $(elem).trigger('classChanged')
        }, delay);
    },

    animationBlocks() {
        if ($("[data-visible]").length > 0) {
            gsap.utils.toArray("[data-visible]").forEach((elem, i) => {
                ScrollTrigger.create({
                    trigger: elem,
                    // toggleClass: 'active',
                    //	once: true,
                    toggleActions: "play play none none",
                    start: this._config.thresholdStart,
                    markers: false,
                    id: `visible-anim-${i}`,
                    onEnter: () => {
                        const delay = $(elem).data("delay") ? parseFloat($(elem).data("delay")) * 1000 : 0;
                        setTimeout(() => {
                            $(elem).addClass("is-visible");
                            $(elem).trigger('classChanged');
                            if ($(elem).data('animationplayed') !== true) {
                                $(elem).trigger('playAnimation');
                            }
                            elem.setAttribute('data-animationplayed', true);
                        }, delay);
                    },
                    onLeaveBack: () => {
                        // $(elem).removeClass("is-visible");
                    },
                });
            });
        }
        if ($("[data-title-animation]").length > 0) {
            gsap.utils.toArray("[data-title-animation]").forEach((elem, i) => {
                if ($(elem).data('autoplay') !== false) {
                    ScrollTrigger.create({
                        trigger: elem,
                        toggleActions: "play play none none",
                        start: this._config.thresholdStart,
                        // end: "bottom 100%",
                        markers: false,
                        id: `visible-title-${i}`,
                        onEnter: () => {
                            if ($(elem).hasClass("played")) {
                                return;
                            }
                            const delay = $(elem).data("delay") ? parseFloat($(elem).data("delay")) * 1000 : 0;
                            setTimeout(() => {
                                this.titleAnimation(elem);
                                $(elem).addClass("played");
                            }, delay);
                        },
                    });
                }
            });
        }
        ScrollTrigger.refresh();
    },
};
export default texts_animations;
